import * as Yup from "yup";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import { useMutation, useQuery } from "react-query";

import CustomAlert from "../../components/CustomAlert";
import CustomDialog from "../../components/CustomDialog";
import { Autocomplete as FormikAutocomplete } from "formik-material-ui-lab";
import { TextField as FormikTextField } from "formik-material-ui";
import { fetchDocCategories } from "../../../services/documentCategoriesService";
import { updateDocument } from "../../../services/documentsService";
import useLocale from "../../../hooks/useLocale";
import { useState } from "react";

const UpdateDialog = ({ open, close, refetch, selectedItem }) => {
  const [error, setError] = useState("");
  const { t } = useLocale();
  const { data: docCategories } = useQuery("docCategories", fetchDocCategories);
  // Mutation for creating data
  const { mutate } = useMutation(updateDocument, {
    onSuccess: (data) => {
      refetch();
      close();
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });

  const validationSchema = Yup.object().shape({
    dscr: Yup.string().required(t("Field is required")).max(512, t("Too long")),
    cat_id: Yup.object()
      .shape({ id: Yup.number().required(t("Field is required")).nullable() })
      .nullable()
      .required(t("Field is required")),
  });

  const handleUpdateItem = (values) => {
    mutate({
      ...values,
      cat_id: values.cat_id.id,
      id: selectedItem.id,
    });
  };

  return (
    <CustomDialog open={open} maxWidth="sm" onClose={close}>
      <DialogTitle id="form-dialog-title">{t("Edit Document")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t(
            "Fill in the form below and then click on Save to update the Document"
          )}
        </DialogContentText>
      </DialogContent>
      <CustomAlert
        open={!!error}
        close={() => {
          setError("");
        }}
        message={t("A network error occured, please try again later")}
      />
      <Formik
        initialValues={{
          dscr: selectedItem?.dscr,
          cat_id: { id: selectedItem?.cat_id, dscr: selectedItem.category },
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          handleUpdateItem(values);
          setSubmitting(false);
        }}
      >
        {({ submitForm, isSubmitting, touched, errors, values }) => (
          <Form>
            <DialogContent>
              <Field
                margin="normal"
                component={FormikTextField}
                fullWidth
                name="dscr"
                label={t("Description")}
              />
              <Field
                name="cat_id"
                component={FormikAutocomplete}
                options={docCategories || []}
                defaultValue={
                  docCategories?.find(
                    (category) => category?.id === values?.cat_id
                  ) || {}
                }
                getOptionLabel={(option) => option?.dscr}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={touched["cat_id"] && !!errors["cat_id"]}
                    helperText={touched["cat_id"] && errors["cat_id"]}
                    label={t("Document Category")}
                    variant="outlined"
                    margin="normal"
                  />
                )}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={submitForm} color="primary">
                {t("Save")}
              </Button>
              <Button onClick={close} color="primary">
                {t("Cancel")}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </CustomDialog>
  );
};

export default UpdateDialog;
